
import {useContext, useEffect, useMemo, useState} from 'react';
import './style/payment.css';
import PayAlert from './PayAlert';
import { ClientContext } from '../../../contextApi/ClientContext';
import { AppContext } from '../../../contextApi/ContextApi';
import PaymentTable from './PaymentTable';
import NotFound404 from "../../NotFound404.jsx";
import UpdateInfoBeforePayment from './UpdateInfoBeforePayment';

export default function Payment({website}) {
  const {primary_color, secondary_color, accent_color, currentUser, hasCategories} = useContext(AppContext);
  const { payAlertFlag, setPayAlertFlag, cartArr } = useContext(ClientContext);

  const [needUpdate, setNeedUpdate] = useState(false);
  const [problem, setProblem] = useState("");
  const [hoverPay, setHoverPay] = useState(false);
  const [isMissingAddress, setIsMissingAddress] = useState(()=>{return currentUser?.address===""});
  const [isMissingPaymentMethod, setIsMissingPaymentMethod] = useState(()=>{
    return currentUser?.paymentMethod===undefined || currentUser?.paymentMethod===null ||(currentUser?.paymentMethod?.cardNum===null&&currentUser?.paymentMethod?.expDate===null&&currentUser?.paymentMethod?.cvv===null);
  });

  useEffect(()=>{
    if(problem !== ""){
      setTimeout(() => {
        setProblem("");
      }, 5000);
    }
  },[problem])


  const _finalPrice = useMemo(() => {
    const total = cartArr?.reduce((sum, item) => {
      const price = item.price;

      return sum + price * item.amount;
    }, 0);

    return Math.max(0, Number(total?.toFixed(2)));
  }, [cartArr]);

  const handlePay=()=>{
    if(_finalPrice === 0){
      setProblem("העגלה ריקה!");
      return;
    }
    setPayAlertFlag(true);
  }
  
  if(!hasCategories || !currentUser) return <NotFound404/>
  return (
    <>
      {!needUpdate ? <div id='payment_mainContainer' dir='rtl'>
        <h1 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>עמוד התשלום</h1>
        <div id='ul_mainDiv' style={{backgroundColor:primary_color, color:accent_color, boxShadow:`2px 2px 3px ${accent_color}`}}>
          <h3 style={{textShadow:`2px 2px 3px ${secondary_color}`, width:"100%", height:"10%"}} dir="rtl">פירוט מוצרים לתשלום</h3>
          <div id='ul_mainDiv_sub'>
            <PaymentTable/>
            <h3 dir='rtl' className='finalPrice' style={{color:accent_color, textShadow:`2px 2px 4px ${secondary_color}`}}>{cartArr.length===0 ? "העגלה ריקה" : `סכום סופי: ${_finalPrice}₪`}</h3>
            <p style={{color:accent_color, fontWeight:"bold",fontSize:"18px"}}>{problem}</p>
            <div className='payBtnDiv'>
              <button className='payBtn' onMouseEnter={()=>{setHoverPay(true)}} onMouseLeave={()=>{setHoverPay(false)}} onClick={()=>{handlePay()}} style={{backgroundColor:!hoverPay ? secondary_color : accent_color, color:!hoverPay ? accent_color : primary_color}}>בצע תשלום</button>
            </div>
          </div>
        </div>
        {payAlertFlag && <PayAlert setPayAlertFlag={setPayAlertFlag} setProblem={setProblem} website={website} isMissingAddress={isMissingAddress} isMissingPaymentMethod={isMissingPaymentMethod} setNeedUpdate={setNeedUpdate} needUpdate={needUpdate} _finalPrice={_finalPrice}/>}
      </div> :
      <UpdateInfoBeforePayment website={website} setNeedUpdate={setNeedUpdate} needUpdate={needUpdate} isMissingAddress={isMissingAddress} setIsMissingAddress={setIsMissingAddress} setIsMissingPaymentMethod={setIsMissingPaymentMethod} isMissingPaymentMethod={isMissingPaymentMethod} setProblem={setProblem} _finalPrice={_finalPrice}/>
      }
    </>
  )
}
